class ProductModal {
      constructor() {
    this.isLoading = false;
    this.currentModal = null;
    this.init();
  }

  init() {
    document.addEventListener('click', this.handleProductClick.bind(this));
    document.addEventListener('click', this.handleCloseClick.bind(this));
    document.addEventListener('keydown', this.handleEscapeKey.bind(this));
    document.addEventListener('change', this.handleVariantChange.bind(this));
    document.addEventListener('click', this.handleQuantityClick.bind(this));
    document.addEventListener('click', this.handleThumbnailClick.bind(this));
    document.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  async handleProductClick(event) {
    const trigger = event.target.closest('.product-modal-trigger');
    if (!trigger) return;
    
    event.preventDefault();
    
    const productId = trigger.dataset.productId;
    const productUrl = trigger.dataset.productUrl;
    
    console.log('Product click detected:', { productId, productUrl, trigger });
    
    if (!productId || this.isLoading) {
      console.log('Missing productId or already loading:', { productId, isLoading: this.isLoading });
      return;
    }
    
    if (!productUrl) {
      console.error('Missing product URL');
      this.showError('Product URL not found');
      return;
    }
    
    await this.openModal(productId, productUrl);
  }

  async openModal(productId, productUrl) {
    try {
      this.isLoading = true;
      console.log('Opening modal for product:', productId, 'URL:', productUrl);
      
      let modal = document.getElementById(`ProductModal-${productId}`);
      
      if (!modal) {
        // Show loading state
        const loadingModal = this.createLoadingModal(productId);
        document.body.appendChild(loadingModal);
        this.showModal(loadingModal); // Apply body overflow hidden immediately
        
        try {
          // Fetch the product page content
          const productHTML = await this.fetchProductHTML(productUrl);
          
          // Remove loading modal
          this.hideModal(loadingModal);
          loadingModal.remove();
          
          // Create modal with the product page content
          modal = this.createProductModal(productHTML, productId);
          document.body.appendChild(modal);
          
        } catch (fetchError) {
          this.hideModal(loadingModal);
          loadingModal.remove();
          throw new Error(`Failed to load product page: ${fetchError.message}`);
        }
      }
      
      this.showModal(modal);
      this.currentModal = modal;
      
    } catch (error) {
      console.error('Error opening product modal:', error);
      this.showError(`Failed to load product details: ${error.message}`);
    } finally {
      this.isLoading = false;
    }
  }

  async fetchProductHTML(productUrl) {
    try {
      console.log('Fetching product page HTML from:', productUrl);
      
      const response = await fetch(productUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const html = await response.text();
      console.log('Product HTML received');
      return html;
    } catch (error) {
      console.error('Error fetching product HTML:', error);
      throw new Error(`Failed to fetch product page: ${error.message}`);
    }
  }

  createProductModal(html, productId) {
    console.log('Creating modal from HTML for product:', productId);
    
    // Parse the HTML to extract the main content
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Get the main content area (everything inside the body, excluding header/footer)
    const mainContent = doc.querySelector('main, .main-content, #MainContent') || doc.querySelector('body');
    
    if (!mainContent) {
      throw new Error('Could not find main content in HTML');
    }
    
    // Clone the main content to avoid modifying the original
    const contentClone = mainContent.cloneNode(true);
    
    // // Remove the "Other industry favorites" / related products section
    // const relatedProductsSection = contentClone.querySelector('[data-section-type="related-products"], .related-products, [id*="related-products"], [class*="related-products"]');
    // if (relatedProductsSection) {
    //   relatedProductsSection.remove();
    //   console.log('Removed related products section from modal');
    // }
    
    // // Also remove any section that contains "related" or "recommendations" in its ID or class
    // const recommendationSections = contentClone.querySelectorAll('[id*="recommendations"], [class*="recommendations"], [data-section-type*="recommendations"]');
    // recommendationSections.forEach(section => {
    //   section.remove();
    //   console.log('Removed recommendation section from modal');
    // });
    
    // Create the modal structure with proper ModalDialog-compatible markup
    const modal = document.createElement('modal-dialog');
    modal.id = `ProductModal-${productId}`;
    modal.className = 'product-modal';
    modal.dataset.productId = productId;
    
    // Create modal content with the cleaned main product page content
    // Include id="ModalClose-${productId}" for ModalDialog compatibility
    modal.innerHTML = `
      <div role="dialog" aria-modal="true" class="product-modal__content" tabindex="-1">
        <button id="ModalClose-${productId}" type="button" class="product-modal__toggle" aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        
        <div class="product-modal__container">
          ${contentClone.innerHTML}
        </div>
      </div>
    `;
    
    // Copy stylesheets from the product page
    this.loadProductPageAssets(doc);
    
    // Initialize any product scripts
    this.initializeProductScripts(modal);
    
    return modal;
  }

  loadProductPageAssets(doc) {
    // Find and load any product-specific stylesheets
    const stylesheets = doc.querySelectorAll('link[rel="stylesheet"]');
    stylesheets.forEach(link => {
      if (!document.querySelector(`link[href="${link.href}"]`)) {
        document.head.appendChild(link.cloneNode(true));
      }
    });
  }

  initializeProductScripts(modal) {
    // Execute any scripts that were loaded with the page content
    const scripts = modal.querySelectorAll('script');
    scripts.forEach(script => {
      if (script.src) {
        // For external scripts, check if not already loaded before adding
        const scriptSrc = script.src;
        if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
          const newScript = document.createElement('script');
          newScript.src = scriptSrc;
          newScript.defer = true;
          document.head.appendChild(newScript);
        }
      }
      // Skip inline scripts - they often contain Liquid template syntax or module-specific code
      // that can't be safely executed in isolation. The product page components will handle their own initialization.
    });
    
    // Load and initialize magnify.js for image zoom functionality
    this.loadMagnifyScript();
    
    // Trigger DOMContentLoaded-like events for the modal content
    const modalContent = modal.querySelector('.product-modal__container');
    if (modalContent) {
      modalContent.dispatchEvent(new CustomEvent('DOMContentLoaded', { bubbles: true }));
    }
  }

  loadMagnifyScript() {
    // Check if magnify.js is already loaded
    if (typeof enableZoomOnHover === 'function') {
      // If already loaded, reinitialize zoom for new modal images
      this.initializeZoomForModal();
      return;
    }
    
    // Check if magnify.js is available on the page (loaded by product sections)
    const existingMagnifyScript = document.querySelector('script[id*="EnableZoomOnHover"]');
    if (existingMagnifyScript) {
      // Script tag exists, wait for it to load
      const checkLoaded = setInterval(() => {
        if (typeof enableZoomOnHover === 'function') {
          clearInterval(checkLoaded);
          this.initializeZoomForModal();
        }
      }, 100);
      // Stop checking after 3 seconds
      setTimeout(() => clearInterval(checkLoaded), 3000);
      return;
    }
    
    // Load magnify.js dynamically - extract asset path from product-modal.js itself
    const script = document.createElement('script');
    script.id = 'magnify-script';
    
    // Get the asset URL base from the current script (product-modal.js)
    const productModalScript = document.querySelector('script[src*="product-modal"]');
    if (productModalScript) {
      // Extract base URL and construct magnify.js path
      const assetBaseUrl = productModalScript.src.substring(0, productModalScript.src.lastIndexOf('/'));
      script.src = `${assetBaseUrl}/magnify.js`;
    } else {
      // Fallback: try common Shopify asset patterns
      script.src = `/assets/magnify.js`;
    }
    
    script.defer = true;
    script.onload = () => {
      console.log('Magnify.js loaded successfully for modal');
      this.initializeZoomForModal();
    };
    script.onerror = () => {
      console.warn('Could not load magnify.js from:', script.src);
      console.log('Modal will work without zoom functionality');
    };
    document.head.appendChild(script);
  }

  initializeZoomForModal() {
    if (typeof enableZoomOnHover !== 'function') return;
    
    // Remove any existing zoom overlays when opening new modal
    const existingOverlays = document.querySelectorAll('.image-magnify-full-size');
    existingOverlays.forEach(overlay => overlay.remove());
    
    // Disable default modal-opener behavior inside our product modal
    const modalOpeners = this.currentModal?.querySelectorAll('modal-opener, .product__modal-opener');
    modalOpeners?.forEach(opener => {
      const button = opener.querySelector('button');
      if (button) {
        button.style.display = 'none'; // Hide the default lightbox button
      }
    });
    
    // Wait a bit for DOM to be ready, then initialize zoom
    setTimeout(() => {
      // Initialize zoom for standard hover images
      enableZoomOnHover(2, '.image-magnify-hover');
      
      // Initialize zoom for lightbox images (used in product pages)
      enableZoomOnHover(2, '.image-magnify-lightbox');
      
      console.log('Zoom initialized for modal images');
    }, 100);
  }


  createLoadingModal(productId) {
    const modal = document.createElement('modal-dialog');
    modal.id = `ProductModal-${productId}`;
    modal.className = 'product-modal';
    // Include id="ModalClose-${productId}" for ModalDialog compatibility
    modal.innerHTML = `
      <div role="dialog" aria-modal="true" class="product-modal__content" tabindex="-1">
        <button id="ModalClose-${productId}" type="button" class="product-modal__toggle" aria-label="Close" style="display: none;">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="product-modal__container" style="text-align: center; padding: 60px 40px;">
          <div class="loading-spinner" style="margin: 0 auto 20px;">
            <div style="width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #007bff; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          </div>
          <p>Loading product details...</p>
        </div>
      </div>
    `;
    return modal;
  }


  showModal(modal) {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    const content = modal.querySelector('.product-modal__content');
    if (content) {
      content.focus();
    }
  }

  hideModal(modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    
    // Remove any zoom overlays when closing modal
    const existingOverlays = document.querySelectorAll('.image-magnify-full-size');
    existingOverlays.forEach(overlay => overlay.remove());
    
    this.currentModal = null;
  }

  handleCloseClick(event) {
    if (event.target.classList.contains('product-modal') || 
        event.target.closest('.product-modal__toggle')) {
      const modal = event.target.closest('.product-modal');
      if (modal) {
        this.hideModal(modal);
      }
    }
  }

  handleEscapeKey(event) {
    if (event.key === 'Escape' && this.currentModal) {
      this.hideModal(this.currentModal);
    }
  }

  handleVariantChange(event) {
    // Product page components handle their own variant changes
  }

  handleQuantityClick(event) {
    // Product page components handle their own quantity changes  
  }

  handleThumbnailClick(event) {
    // Product page components handle their own thumbnail clicks
  }

  async handleFormSubmit(event) {
    // Product page form handlers will manage form submission
    // The modal stays open so users can continue shopping
  }

  showError(message) {
    console.error('Product Modal Error:', message);
    // Show a simple error message or redirect to product page
    alert(`Unable to load product details. ${message}`);
  }
}

// Prevent multiple instances
if (!window.productModalInstance) {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.productModalInstance = new ProductModal();
    });
  } else {
    window.productModalInstance = new ProductModal();
  }
}